import { useAuth } from "~/context/AuthContext";

export const DEFAULT_BRAND_COLOR = "#f97316";

export function normalizeHexColor(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const withHash = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
  if (!/^#[0-9A-Fa-f]{6}$/.test(withHash)) return null;
  return withHash.toLowerCase();
}

export function useTeamBrandColor(overrideColor?: string): string {
  const { user } = useAuth();
  if (overrideColor) return overrideColor;
  const activeTeam = user?.teams?.find(
    (t) => String(t.id) === String(user?.team_id)
  );
  return activeTeam?.brand_color || DEFAULT_BRAND_COLOR;
}
